export default __webpack_public_path__ + "static/media/ripple5.4a2b29e6.png";